export const handleButtonModifications = (button, actualButton) => {
    if (button === actualButton) {
        button.setAttribute('aria-pressed', 'true');
        button.classList.add('spv-button--primary');
        button.classList.remove('spv-button--secondary');
    }
    else {
        button.setAttribute('aria-pressed', 'false');
        button.classList.remove('spv-button--primary');
        button.classList.add('spv-button--secondary');
    }
};
export const sortTags = (tags) => {
    return tags.sort((a, b) => {
        if (a.toLocaleLowerCase() === 'ongoing')
            return -1;
        if (b.toLocaleLowerCase() === 'ongoing')
            return 1;
        return 0;
    });
};
//# sourceMappingURL=helpers.js.map